import { Amplify } from 'aws-amplify';

let configuredPoolId = null;

/**
 * Configure Amplify guest credentials for Rekognition Face Liveness (StartFaceLivenessSession).
 * Safe to call multiple times; re-configures only when identity pool id changes.
 */
export function configureLivenessAmplify(identityPoolId, region = 'us-west-2') {
  if (!identityPoolId) {
    return false;
  }
  if (configuredPoolId === identityPoolId) {
    return true;
  }
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId,
        allowGuestAccess: true,
      },
    },
  });
  configuredPoolId = identityPoolId;
  return true;
}

export function getConfiguredLivenessPoolId() {
  return configuredPoolId;
}
